webpackJsonp([14],{

/***/ "/fn3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TOKEN_KEY */
/* unused harmony export setToken */
/* unused harmony export getToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return browser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return copyValue; });
/* unused harmony export decryptData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return encyMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return photoCompressMethod; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsencrypt__ = __webpack_require__("4C6m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsencrypt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsencrypt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);



// cookie保存的天数
var TOKEN_KEY = 'LOGININFO';
var setToken = function setToken(token) {
  __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(TOKEN_KEY, token, { expires: 0.05 || 1 });
};

var getToken = function getToken() {
  var token = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(TOKEN_KEY);
  if (token) return token;else return false;
};

var browser = {
  versions: function () {
    var u = navigator.userAgent,
        app = navigator.appVersion;
    return {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
      alipay: u.indexOf('AlipayClient') > -1, //是否支付宝
      qq: u.match(/\sQQ/i) == " qq" //是否QQ
    };
  }(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
/**
 * copyValue 复制功能
 * @param { val } val
 * @description blooean
 */
var copyValue = function copyValue(val) {
  var cValue = val.trim();
  if (browser.versions.ios) {
    var input = document.createElement('input');
    input.style.opacity = 0;
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', cValue);
    input.setAttribute('id', 'copyInput');
    document.body.appendChild(input);
    window.getSelection().removeAllRanges(); //将页面所有的文本区域都从选区中移除
    var range = document.createRange(); //创建一个文本区域
    var test = window.document.getElementById('copyInput'); //获取所需要复制的节点
    range.selectNode(test); //将我们的所选节点添加到文本区域中
    window.getSelection().addRange(range); //将文本区域添加至选区中
    if (document.execCommand('copy')) {
      document.execCommand('copy'); //执行浏览器的复制命令
      setTimeout(function () {
        document.body.removeChild(input);
        window.getSelection().removeAllRanges();
      }, 500);
      return true;
    } else {
      return false;
    }
  } else {
    var _input = document.createElement('input');
    _input.style.opacity = 0;
    _input.setAttribute('readonly', 'readonly');
    _input.setAttribute('value', cValue);
    document.body.appendChild(_input);
    _input.select();
    if (document.execCommand('copy')) {
      document.execCommand('copy');
      setTimeout(function () {
        document.body.removeChild(_input);
      }, 500);
      return true;
    } else {
      return false;
    }
  }
};
var decryptData = function decryptData(siKey, data) {
  var decryptMethod = new __WEBPACK_IMPORTED_MODULE_0_jsencrypt__["JSEncrypt"]();
  decryptMethod.setPrivateKey(siKey);
  var rsaPassWord = decryptMethod.decrypt(data);
  return rsaPassWord;
};
/**
 * @param {Number} str 手机号码
 * @returns {String} 处理后的字符串
 * @description 手机号码加密处理
 */
var encyMobile = function encyMobile(mobile) {
  var mobileAfter = mobile.substring(0, 3);
  var i = 0;
  while (mobile.length - 7 > i) {
    i++;
    mobileAfter += '*';
  }
  mobileAfter += mobile.substring(mobile.length - 4, mobile.length);
  return mobileAfter;
};

/**
 * 压缩图片
 */

var photoCompressMethod = function photoCompressMethod(path, obj, type, callback) {
  var img = new Image();
  img.src = path;
  img.onload = function () {
    var that = this;
    // 默认按比例压缩
    var w = that.width,
        h = that.height,
        scale = w / h;
    w = obj.width || w;
    h = obj.height || w / scale;
    var quality = 0.7; // 默认图片质量为0.7
    //生成canvas
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    // 创建属性节点
    var anw = document.createAttribute("width");
    anw.nodeValue = w;
    var anh = document.createAttribute("height");
    anh.nodeValue = h;
    canvas.setAttributeNode(anw);
    canvas.setAttributeNode(anh);
    ctx.drawImage(that, 0, 0, w, h);
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality;
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality);
    // 回调函数返回base64的值

    // 控制图片尺寸小于1M
    while (base64.length / 1024 > 1024) {
      quality -= 0.01;
      base64 = canvas.toDataURL("image/jpeg", quality);
    }

    callback(base64, type);
  };
};

/***/ }),

/***/ "/sHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "view"
  }, [_c('router-view')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4ml/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DEm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

var listenList = [];
var imageCatcheList = [];

if (!Array.prototype.remove) {
	Array.prototype.remove = function (item) {
		if (!this.length) return;
		var index = this.indexOf(item);
		if (index > -1) {
			this.splice(index, 1);
			return this;
		}
	};
}
// 检测是否已加载
var isAlredyLoad = function isAlredyLoad(imageSrc) {
	if (imageCatcheList.indexOf(imageSrc) > -1) {
		return true;
	} else {
		return false;
	}
};
//检测图片是否可以加载，如果可以则进行加载
var isCanShow = function isCanShow(item) {
	var ele = item.ele;
	var src = item.src;

	//图片距离页面顶部的距离
	var top = ele.getBoundingClientRect().top;
	//页面可视区域的高度
	var windowHeight = window.innerHeight || 0;
	//top + 10 已经进入了可视区域10像素
	if (top + 10 < windowHeight) {
		var image = new Image();
		image.src = src;
		image.onload = function () {
			ele.src = src;
			imageCatcheList.push(src);
			listenList.remove(item);
		};
		return true;
	} else {
		return false;
	}
};

var onListenScroll = function onListenScroll() {
	window.addEventListener('scroll', function () {
		var length = listenList.length;
		for (var i = 0; i < length; i++) {
			isCanShow(listenList[i]);
		}
	});
};
var addListener = function addListener(el) {
	//绑定的图片地址
	var imageSrc = el.getAttribute('data-src');
	//如果已经加载过，则无需重新加载，直接将src赋值
	if (isAlredyLoad(imageSrc)) {
		el.src = imageSrc;
		return false;
	}
	var item = {
		ele: el,
		src: imageSrc
	};
	//再看看是否可以显示此图片
	if (isCanShow(item)) {
		return;
	}
	//否则将图片地址和元素均放入监听的lisenList里
	listenList.push(item);

	//然后开始监听页面scroll事件
	onListenScroll();
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('loadzj', {
	// bind表示这个自定义指令一绑定到dom上，就开始自动执行
	bind: function bind(el) {
		var bigSrc = el.getAttribute('src'),
		    smallSrc = bigSrc.replace('img.ysf.mobi/', 'img.ysf.mobi/images/') + '?width=50&height=50';
		el.setAttribute('src', smallSrc);
		el.setAttribute('data-src', bigSrc);
		var smallImage = new Image();
		smallImage.src = smallSrc;
		smallImage.onload = function () {
			addListener(el);
		};
	}
	// inserted: addListener,
	// updated: addListener,
});

/***/ }),

/***/ "KFH/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/**
 * auth: Tank
 * date: 2017-8-31
 * desc: 注册过滤器
 */



// 定义过滤器
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('statusFilter', function (value) {
    var result = '';
    switch (+value) {
        case 0:
            {
                result = '自由人';
                break;
            }
        case 1:
            {
                result = '跟进中';
                break;
            }
        case 2:
            {
                result = '已登录';
                break;
            }
    }
    return result;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('joinServicearea', function (value) {
    var result = '';
    if (value && value.length) {
        result = value.join('、');
    } else {
        result = value;
    }
    return result;
});

// 多于5个字显示省略号
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('nameEllipsis', function (value) {
    value += '';
    var result = '';
    if (value.length > 5) {
        result = value.substring(0, 5) + '...';
    } else {
        result = value;
    }
    return result;
});

// 记录状态
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('reportstatus', function (value) {
    value += '';
    var result = '';
    switch (value) {
        default:
        case '0':
            {
                result = '全部';
                break;
            }
        case '1':
            {
                result = '有报备';
                break;
            }
        case '2':
            {
                result = '有到访';
                break;
            }
        case '3':
            {
                result = '有成交';
            }
    }
    return result;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('delDecimals', function (Num) {
    var newNum;
    newNum = "";
    Num += '';
    if (Num) {
        newNum = Num % 1 == 0 ? Math.floor(Num) : (Num * 1).toFixed(2);
        return newNum;
    } else {
        return '0';
    };
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('savedecimal', function (num) {
    var decimalNum = "",
        newNum = 0;
    newNum = num * 1;
    if (newNum) {
        decimalNum = newNum % 1 == 0 ? newNum.toFixed(2) : (Math.floor(newNum * 100) / 100).toFixed(2);
        return decimalNum;
    } else {
        return '0.00';
    }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b04ce6de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("/sHO");
function injectStyle (ssrContext) {
  __webpack_require__("N6QL")
  __webpack_require__("ShPA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b04ce6de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N1kN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N6QL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mytools_directive__ = __webpack_require__("DEm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mytools_mytools__ = __webpack_require__("wQAC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mytools_filters__ = __webpack_require__("KFH/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vant__ = __webpack_require__("Fd2+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_viewer__ = __webpack_require__("EAZf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lib_flexible_flexible__ = __webpack_require__("sVYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lib_flexible_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lib_flexible_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vant_lib_index_css__ = __webpack_require__("4ml/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vant_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vant_lib_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_viewerjs_dist_viewer_css__ = __webpack_require__("N1kN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_css_style_less__ = __webpack_require__("PijW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_css_style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_css_style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_js_filters__ = __webpack_require__("d9AR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vant_lib_icon_local_css__ = __webpack_require__("sEnP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vant_lib_icon_local_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vant_lib_icon_local_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_polyfill__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;









// import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
// let vConsole = new VConsole() // 初始化
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_v_viewer___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vant__["a" /* default */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__mytools_mytools__["a" /* install */])(__WEBPACK_IMPORTED_MODULE_1_vue__["default"]);
__WEBPACK_IMPORTED_MODULE_9_v_viewer___default.a.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.ignoredElements = ['wx-open-launch-app'];
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "PijW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ShPA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: {
      name: 'lose'
    }
  }, { // 首页
    path: '/index',
    name: 'index',
    title: '认证信息确认',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "42Hy"));
    }
  }, { // share
    path: '/share',
    name: 'share',
    title: '分享页',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Eg0l"));
    }
  }, { // 招募
    path: '/unionShare',
    name: 'unionShare',
    title: '邀请',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "OKXq"));
    }
  }, { // 邀请成功
    path: '/succeed',
    name: 'succeed',
    title: '邀请成功',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "0UJ/"));
    }
  }, { // 链接失效
    path: '/shareExpired',
    name: 'shareExpired',
    title: '链接失效',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "3jc4"));
    }
  }, { // 电子签约
    path: '/signature',
    name: 'signature',
    title: '电子签约',
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "aX6m"));
    }
  }, { // 签约成功
    path: '/signSucceed',
    name: 'signSucceed',
    title: '电子签约',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "Z4kg"));
    }
  }, { // 签约链接失效
    path: '/Expired',
    name: 'Expired',
    title: '链接失效',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "MKm+"));
    }
  }, { // 预览
    path: '/preview',
    name: 'preview',
    title: '预览',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "tatI"));
    }
  }, { // 投资成功提示
    path: '/successMsg',
    name: 'SuccessMsg',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "66Io"));
    }
  }, { // Invitation
    path: '/invitation',
    name: 'invitation',
    title: '邀请回执',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "xKBk"));
    }
  }, { // Invitation
    path: '/verifyCode',
    name: 'verifyCode',
    title: '验证邀请回执',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "y4rQ"));
    }
  }, { // lose
    path: '/lose',
    name: 'lose',
    title: '页面丢失了',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "dT0f"));
    }
  }, { // 以上路由都匹配不到的时候重定向到首页
    path: '/*',
    redirect: {
      name: 'lose'
    }
  }]
});
router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  if (to.name == 'PeriodDetail' && (from.name == 'projectInfoRecordDetail' || from.name == 'DeveloperReturnList')) {
    var periodDate = localStorage.getItem('periodDate');
    to.query.date = periodDate;
  } else if (from.name != 'PeriodDetail' && (to.name != 'projectInfoRecordDetail' || to.name != 'DeveloperReturnList')) {
    localStorage.removeItem('periodDate');
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "d9AR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('arabiaToChinese', function (Num) {
  for (var i = Num.length - 1; i >= 0; i--) {
    Num = Num.replace(",", ""); //替换Num中的“,”
    Num = Num.replace(" ", ""); //替换Num中的空格
  }
  if (isNaN(Num)) {
    //验证输入的字符是否为数字
    //alert("请检查小写金额是否正确");
    return;
  }
  //字符处理完毕后开始转换，采用前后两部分分别转换
  var part, newchar, perchar, tmpnewchar;
  part = String(Num).split(".");
  newchar = "";
  //小数点前进行转化
  for (var _i = part[0].length - 1; _i >= 0; _i--) {
    if (part[0].length > 10) {
      //alert("位数过大，无法计算");
      return "";
    } //若数量超过拾亿单位，提示
    tmpnewchar = "";
    perchar = part[0].charAt(_i);
    switch (perchar) {
      case "0":
        tmpnewchar = "零" + tmpnewchar;break;
      case "1":
        tmpnewchar = "一" + tmpnewchar;break;
      case "2":
        tmpnewchar = "二" + tmpnewchar;break;
      case "3":
        tmpnewchar = "三" + tmpnewchar;break;
      case "4":
        tmpnewchar = "四" + tmpnewchar;break;
      case "5":
        tmpnewchar = "五" + tmpnewchar;break;
      case "6":
        tmpnewchar = "六" + tmpnewchar;break;
      case "7":
        tmpnewchar = "七" + tmpnewchar;break;
      case "8":
        tmpnewchar = "八" + tmpnewchar;break;
      case "9":
        tmpnewchar = "九" + tmpnewchar;break;
    }
    switch (part[0].length - _i - 1) {
      case 0:
        tmpnewchar = tmpnewchar;break;
      case 1:
        if (perchar != 0) tmpnewchar = tmpnewchar + "十";break;
      case 2:
        if (perchar != 0) tmpnewchar = tmpnewchar + "百";break;
      case 3:
        if (perchar != 0) tmpnewchar = tmpnewchar + "千";break;
      case 4:
        tmpnewchar = tmpnewchar + "万";break;
      case 5:
        if (perchar != 0) tmpnewchar = tmpnewchar + "十";break;
      case 6:
        if (perchar != 0) tmpnewchar = tmpnewchar + "百";break;
      case 7:
        if (perchar != 0) tmpnewchar = tmpnewchar + "千";break;
      case 8:
        tmpnewchar = tmpnewchar + "亿";break;
      case 9:
        tmpnewchar = tmpnewchar + "十";break;
    }
    newchar = tmpnewchar + newchar;
  }
  //替换所有无用汉字，直到没有此类无用的数字为止
  while (newchar.search("零零") != -1 || newchar.search("零亿") != -1 || newchar.search("亿万") != -1 || newchar.search("零万") != -1) {
    newchar = newchar.replace("零亿", "亿");
    newchar = newchar.replace("亿万", "亿");
    newchar = newchar.replace("零万", "万");
    newchar = newchar.replace("零零", "零");
  }
  //替换以“一十”开头的，为“十”
  if (newchar.indexOf("一十") == 0) {
    newchar = newchar.substr(1);
  }
  //替换以“零”结尾的，为“”
  if (newchar.lastIndexOf("零") == newchar.length - 1) {
    newchar = newchar.substr(0, newchar.length - 1);
  }
  return newchar;
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('numberToMoney', function (Num) {
  var money = Num.replace(/(?=\B(?:\d{3})+\b)(\d{3}(?:\.\d+$)?)/g, ',$1');
  return money;
});

/***/ }),

/***/ "sEnP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mytools_util__ = __webpack_require__("/fn3");


var state = {};

var mutations = {};

/***/ }),

/***/ "vmn6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * Bridge
 * @author Tevin
 */
var mybridge = null;
;(function (win) {

    /**
     * Bridge
     * @constructor
     */
    var Bridge = function Bridge() {
        this._callbacks = {};
        this.count = 100;
    };

    /**
     * 发起
     * @param {String} type
     * @param {Object|Function} [data]
     * @param {Function} [callback]
     */
    Bridge.prototype.invoking = function (type, data, callback) {
        //数据检查
        if (data) {
            if (Object.prototype.toString.call(data) == '[object Function]') {
                callback = data;
                data = {};
            } else if (Object.prototype.toString.call(data) != '[object Object]') {
                throw new Error('bridge.invoking 需要接受 JSON 对象！');
            }
        }
        //如果有回调，转存回调
        if (typeof callback != 'undefined') {
            if (typeof this._callbacks[type] == 'undefined') {
                this._callbacks[type] = 'every';
            } else if (this._callbacks[type] == 'once') {
                throw new Error('类型 ' + type + ' 已经被 bridge.register 注册');
            }
            var name = 'cb' + this.count++ + 'at' + Date.now();
            data['_callbackName'] = 'bridge.' + name;
            this[name] = function (res) {
                var data = typeof res == 'string' ? JSON.parse(res) : res;
                callback(data);
                delete this[name];
            };
        }
        if (data) {
            var dataString = typeof data != 'string' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) : data;
        }
        var isIOS = function () {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/(ipad|ipod|iphone)/i) != null) {
                return true;
            } else {
                return false;
            }
        }();
        if (isIOS) {

            var version = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
            try {
                version = parseInt(version[0].replace('OS ', ''), 10);
            } catch (e) {
                version = '';
            }
            if (version >= 7.0 && version < 8.0) {
                if (win.jsBridge && win.jsBridge[type]) {
                    win.jsBridge[type](dataString || '');
                }
            } else if (version >= 8.0) {
                if (win.jsBridge && win.jsBridge[type]) {
                    win.jsBridge[type](dataString || '');
                }
                if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[type]) {
                    window.webkit.messageHandlers[type].postMessage(dataString || ' ');
                }
            }
        } else {
            if (win.jsBridge && win.jsBridge[type]) {
                win.jsBridge[type](dataString || '');
            }
        }
    };

    /**
     * 注册app调用api
     * @param {String} type
     * @param {Function} callback
     */
    Bridge.prototype.on = function (type, callback) {
        if (!type) {
            throw new Error('bridge.on方法需要传入绑定类型！');
        }
        if (typeof this[type] == 'undefined') {
            this[type] = function (res) {
                try {
                    res = typeof res == 'string' ? JSON.parse(res) : res;
                } catch (e) {
                    res = res;
                }
                if (!res.state) {
                    // 兼容ios的数据格式
                    res = {
                        state: {
                            code: 10200,
                            msg: ''
                        },
                        data: res
                    };
                }
                callback(res);
            };
        } else {
            throw new Error('bridge. ' + type + '类型事件已经存在！');
        }
    };
    mybridge = new Bridge();
    // return win.bridge = mybridge;
})(window);

/* harmony default export */ __webpack_exports__["a"] = (mybridge);

/***/ }),

/***/ "wQAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return httpGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return httpPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _tools; });
/* unused harmony export validate */
/* unused harmony export setting */
/* unused harmony export myalert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return install; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Bridge_js__ = __webpack_require__("vmn6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant__ = __webpack_require__("Fd2+");
/* unused harmony reexport bridge */






var state = {
    // 是否可以用Object.defineProperty
    isDefinePropertyInObject: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default.a ? true : false
},
    isArray = function isArray(obj) {
    return Object.prototype.toString.call(obj) == '[object Array]';
},
    extend = function extend(obj1, obj2) {
    if (Object.protytype.toString.call(obj1) == '[object Object]' && arguments.length > 1) {
        for (var i = 0, argTemp; i < arguments.length; i++) {
            argTemp = arguments[i];
            if (Object.protytype.toString.call(argTemp) == '[object Object]') {
                for (var key in argTemp) {
                    if (argTemp.hasOwnProperty(key)) {
                        obj1[key] = argTemp[key];
                    }
                }
            }
        }
    }
    return obj1;
},
    trim = function trim(val) {
    return ('' + val).replace(/(^\s*)|(\s*$)/g, "");
};

var _setting = {
    base: window.location.origin.replace('s.ysf.mobi', 'apiunion.ysf.mobi')
};
var _tools = function () {
    var transKeyName = function transKeyName(type, json) {
        // 下划线字符串转小峰驼
        var toCamel = function toCamel(str) {
            var str2 = '';
            if (str.indexOf('_') < 0) {
                str2 = str;
            } else {
                var words = str.split('_');
                for (var i = 1; i < words.length; i++) {
                    words[i] = words[i].substr(0, 1).toUpperCase() + words[i].substr(1);
                }
                str2 = words.join('');
            }
            return str2;
        };
        //小峰驼字符串转下划线
        var toUnderline = function toUnderline(str) {
            var str2 = '';
            if (/[A-Z]/.test(str)) {
                str2 = str.replace(/([A-Z])/g, function ($1) {
                    return '_' + $1.toLowerCase();
                });
            } else {
                str2 = str;
            }
            return str2;
        };
        var transform = function transform(json, json2) {
            for (var p in json) {
                if (json.hasOwnProperty(p)) {
                    var key;
                    //字符串进行键名转换
                    if (!/^\d+$/.test(p)) {
                        if (type == 'camel') {
                            key = toCamel(p);
                        } else if (type == 'underline') {
                            key = toUnderline(p);
                        }
                    }
                    //数值直接传递
                    else {
                            key = parseInt(p);
                        }
                    //属性为对象时，递归转换
                    if (json[p] instanceof Object) {
                        json2[key] = transform(json[p], isArray(json[p]) ? [] : {});
                    }
                    //属性非对象，为字符串但内容符合json格式，递归转换
                    else if (typeof json[p] == 'string' && /^[\{\[]+("([a-zA-Z][a-zA-Z0-9\-_]*?)"\:(.+?))+[\}\]]+$/.test(json[p])) {
                            json2[key] = JSON.parse(json[p]);
                            json2[key] = transform(json2[key], isArray(json2[key]) ? [] : {});
                            json2[key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json2[key]);
                        }
                        //属性非对象，非json字符串，直接传递
                        else {
                                json2[key] = json[p];
                            }
                }
            }
            return json2;
        };
        return transform(json, isArray(json) ? [] : {});
    };

    var urlParams = null;
    var getUrlParams = function getUrlParams(forceGetAgain) {
        if (!urlParams || forceGetAgain) {
            var url = decodeURIComponent(location.search);
            urlParams = {};
            var arr = url.split("?");
            if (arr.length > 1) {
                arr = arr[1].split("&");
                for (var i = 0, l = arr.length; i < l; i++) {
                    var a = arr[i].split("=");
                    urlParams[a[0]] = a[1];
                }
                urlParams = transKeyName('camel', urlParams);
            }
        }
        return urlParams;
    };

    return {
        transKeyName: transKeyName,
        getUrlParams: getUrlParams
    };
}();

var _validate = function () {
    var vd = {
        isMobile: function isMobile(val) {
            var rgx = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
            return rgx.test(trim(val));
        },
        //匿名电话正则
        isAnonymousMobile: function isAnonymousMobile(val) {
            var rgx = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9])(\*{4}|\x{4}|\X{4})\d{4}$/i;
            return rgx.test(trim(val));
        },
        isRequired: function isRequired(val) {
            return (trim(val) + '').length ? true : false;
        },
        isMatchLength: function isMatchLength(val, len) {
            return trim(val).length == len;
        },
        isLengthInRange: function isLengthInRange(val, arr) {
            var len = trim(val).length;
            return len >= arr[0] && len <= arr[1];
        },
        isInRange: function isInRange(val, arr) {
            return val >= arr[0] && val <= arr[1];
        },
        isIdCard: function isIdCard(val) {
            var rgx = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{4}$/;
            return rgx.test(trim(val));
        },
        isTheSame: function isTheSame(val1, val2) {
            return val1 == val2;
        },
        // 验证密码
        isCorrectPassword: function isCorrectPassword(val) {
            // 只包含数字或字母
            var rgx = /^(?!\d+$)(?![a-z]+$).+$/i;
            return rgx.test(trim(val));
        }
    };
    return vd;
}();

// axios配置
var axiosInstance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    responseType: 'json'
});
axiosInstance.defaults.baseURL =  false ? 'api' : _setting.base;

axiosInstance.interceptors.request.use(function (config) {
    // config.params = _tools.transKeyName('underline', config.params);
    // config.data = _tools.transKeyName('underline', config.data);
    return config;
});
axiosInstance.interceptors.response.use(function (data) {
    data.data = _tools.transKeyName('camel', data.data);
    if (data.data.state.code && data.data.state.code == 20001) {
        __WEBPACK_IMPORTED_MODULE_5_vant__["e" /* Dialog */].alert({
            title: '提示',
            message: '登录已失效,请重新登录'
        }).then(function () {
            __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].push({
                name: 'Index'
            });
        });
    }
    return data.data;
});

var httpGet = function httpGet(url, data, config) {
    if (typeof url !== 'string') {
        alert('$httpGet:url错误.');return;
    }
    return axiosInstance.request({
        url: url,
        method: 'get',
        params: data || {}
    });
};
var httpPost = function httpPost(url, data, config) {
    if (typeof url !== 'string') {
        alert('$httpPost:url错误.');return;
    }
    if (_setting.base) {
        // 正式
        return axiosInstance.request({
            url: url,
            method: 'post',
            data: data || {}
        });
    } else {
        // 测试
        return axiosInstance.request({
            url: url,
            method: 'get', // 为了方便mock数据
            params: data || {}
        });
    }
};
var myalert = function myalert(title) {
    var docfrm = document.createElement('div');
    docfrm.innerHTML = '<div style="position:fixed;z-index:999;width:100%;height:100%;left:0;top:0;background:rgba(0,0,0,.4);">' + '<div style="position:absolute;width:300px;left:50%;top: 50%;background-color:#fff;border-radius:.4rem;-webkit-transform: translate(-50%,-50%);-ms-transform: translate(-50%,-50%);-o-transform: translate(-50%,-50%);transform: translate(-50%,-50%);">' + '<p style="padding:1.3rem 2rem 1.7rem;font-size:1.03rem;color:#333;text-align:center;">' + title + '</p>' + '<a href="javascript:;" style="display:block;height:3rem;line-height:3rem;text-align:center;font-size:1.03rem;color:#1a8fc5;border-top:1px solid #e5e5e5;">确定</a>' + '</div>' + '</div>';
    var alertBox = docfrm.firstChild,
        closeBtn = alertBox.getElementsByTagName('a')[0];

    var cb = function cb(e) {
        document.body.removeChild(alertBox);
    };
    if (closeBtn.addEventListener) {
        closeBtn.addEventListener('click', cb, false);
    }
    if (closeBtn.attachEvent) {
        closeBtn.attachEvent('onclick', cb);
    }

    document.body.appendChild(alertBox);
};

var install = function install(Vue) {
    var result = null;
    var _install = function _install(alias, plugin) {
        if (state.isDefinePropertyInObject) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(Vue.prototype, alias, { value: plugin });
        } else {
            Vue.protytype[alias] = plugin;
        }
    };

    if (Vue && Vue.version) {
        // axios插件实例挂载到Vue的原型链上
        _install('$http', axiosInstance);
        _install('$httpGet', httpGet);
        _install('$httpPost', httpPost);
        // 自定义工具
        _install('$tools', _tools);
        // 自定义工具
        _install('$vd', _validate);
        // 基础设置
        _install('$setting', _setting);
        // 自定义alert
        _install('$myalert', myalert);
        // jsBridge
        _install('$bridge', __WEBPACK_IMPORTED_MODULE_4__Bridge_js__["a" /* default */]);
    } else {
        throw 'install plugin fail.You have to pass the Vue constructor to this module.';
    }
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
    install: function install(Vue) {
        var result = null;
        var _install = function _install(alias, plugin) {
            if (state.isDefinePropertyInObject) {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(Vue.prototype, alias, { value: plugin });
            } else {
                Vue.protytype[alias] = plugin;
            }
        };

        if (Vue && Vue.version) {
            // axios插件实例挂载到Vue的原型链上
            _install('$http', axiosInstance);
            _install('$httpGet', httpGet);
            _install('$httpPost', httpPost);
            // 自定义工具
            _install('$tools', _tools);
            // 自定义工具
            _install('$vd', _validate);
            // 基础设置
            _install('$setting', _setting);
            // 自定义alert
            _install('$myalert', myalert);
            // jsBridge
            _install('$bridge', __WEBPACK_IMPORTED_MODULE_4__Bridge_js__["a" /* default */]);
        } else {
            throw 'install plugin fail.You have to pass the Vue constructor to this module.';
        }
    }
});



/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("ukYY");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* state */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* mutations */]
}));

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	data: function data() {
		return {};
	},

	methods: {},
	computed: {},
	// lifecycle
	created: function created() {},
	mounted: function mounted() {}
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.bc850cf522521f38cd57.js